// @ts-nocheck
import React from 'react';
import {Skeleton, Box} from '@mui/material';
const ScriptPreviewSkeleton = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: 'black'
        }}
      >
        <Skeleton animation='wave' />
        <Skeleton animation='wave' />
        <Skeleton animation='wave' />
        <Skeleton animation='wave' />
        <Skeleton animation='wave' />
        <Skeleton animation='wave' />
        <Skeleton animation='wave' />
      </Box>
    </>
  );
};

ScriptPreviewSkeleton.propTypes = {};

ScriptPreviewSkeleton.defaultProps = {};

export default ScriptPreviewSkeleton;
